import { atom } from 'jotai';

export const isReLoginDialogOpenAtom = atom(false);
